// extracted by mini-css-extract-plugin
module.exports = {"cloudsMobile":"clouds-module--cloudsMobile--3ggiA","cloudsDesktop":"clouds-module--cloudsDesktop--13Yjt"};